$(document).ready(() => {
    const updateTitleHeight = () => {
        let titleHeight = $(".nilecard-collect-point-section .col-left .title").outerHeight(true);
        $(".nilecard-collect-point-section .col-right").css("--title-height", `${titleHeight}px`);
    };

    // Initial call
    updateTitleHeight();

    // Update on window resize
    $(window).on("resize", updateTitleHeight);
});

function animateCounter(element, start, end, duration) {
    const startTime = performance.now();
    const startValue = parseInt(start);
    const endValue = parseInt(end);
    
    function updateCounter(currentTime) {
        const elapsed = currentTime - startTime;
        const progress = Math.min(elapsed / duration, 1);
        
        const easeOutQuart = 1 - Math.pow(1 - progress, 4);
        const currentValue = Math.floor(startValue + (endValue - startValue) * easeOutQuart);
        
        element.textContent = currentValue;
        
        if (progress < 1) {
            requestAnimationFrame(updateCounter);
        } else {
            element.textContent = endValue;
        }
    }
    
    requestAnimationFrame(updateCounter);
}

const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
        if (entry.isIntersecting) {
            const progressBar = $(entry.target);
            progressBar.addClass("active-card");

            setTimeout(() => {
                const counterElement = progressBar.find('.counter');
                if (counterElement.length) {
                    const maxPoints = parseInt(progressBar.attr('data-max'), 10) || 1000;
                    animateCounter(counterElement[0], 0, maxPoints, 2000);
                }
            }, 600);
            
            observer.unobserve(entry.target);
        }
    });
}, {
    threshold: 0.3,
    rootMargin: '0px 0px -100px 0px'
});

$(document).ready(() => {
    const progressBar = $('.nilecard-collect-point-section .collect-point-card');
    if (progressBar.length) {
        observer.observe(progressBar[0]);
    }
});

$(window).on('scroll', () => {
    const scroll = $(window).scrollTop();
    const progressBar = $('.nilecard-collect-point-section .collect-point-card');
    
    if (progressBar.hasClass("active-card")) return;
    
    // Check if screen width is 768px or less
    const isMobile = window.matchMedia('(max-width: 768px)').matches;
    
    // Calculate oTop differently based on screen size
    const oTop = isMobile 
        ? progressBar.offset().top - window.innerHeight
        : progressBar.offset().top - (window.innerHeight - (window.innerHeight / 6));
    
    if (scroll > oTop) {
        progressBar.addClass("active-card");
        
        setTimeout(() => {
            const counterElement = progressBar.find('.counter');
            if (counterElement.length) {
                const maxPoints = parseInt(progressBar.attr('data-max'), 10) || 1000;
                animateCounter(counterElement[0], 0, maxPoints, 2000);
            }
        }, 600);
    }
});

// Throttled version for better performance
// let isScrolling;
// $(window).on('scroll', () => {
//     window.clearTimeout(isScrolling);
//     isScrolling = setTimeout(() => {
//         const scroll = $(window).scrollTop();
//         const progressBar = $('.nilecard-collect-point-section .collect-point-card');
        
//         const isMobile = window.matchMedia('(max-width: 768px)').matches;
//         const oTop = isMobile 
//             ? progressBar.offset().top - window.innerHeight
//             : progressBar.offset().top - (window.innerHeight - (window.innerHeight / 6));
        
//         progressBar.toggleClass("active-card", scroll > oTop);
//     }, 66); // ~15fps
// });